import {BaseCachedService} from "./Core/BaseCachedService";
import {BaseService} from "./Core/BaseService";

class ConservationActionTypeService extends BaseCachedService {
    get Url() { return super.Url + this.PageUrl; }
    get ModelName() { return "Conservation Action Type"; }
    get PrimaryKeyProperty() { return "conservationActionTypeId"; }
    get TitleProperty() { return "name"; }

    get PageUrl() { return "/conservationActionTypes"; }
    get ItemNamePlural() { return "conservation action types" }
    get CreatePermission() { return "create_conservation_action_type" }
    get UpdatePermission() { return "update_conservation_action_type" }
    // get Model() { return new ConservationActionType() }

    GetDefaultModel() {
        return {isCreatable: 1};
    }

    GetModel(conservationActionTypeId) {
        return this.SendRequest(BaseService.GET, conservationActionTypeId);
    }

    CreateModel(conservationActionType) {
        this.FlushCache();
        return this.SendRequest(BaseService.POST, conservationActionType);
    }

    UpdateModel(conservationActionType) {
        this.FlushCache();
        return this.SendRequest(BaseService.PUT, conservationActionType);
    }

    DeleteModel(conservationActionTypeId) {
        this.FlushCache();
        return this.SendRequest(BaseService.DELETE, conservationActionTypeId);
    }
}

export const service = new ConservationActionTypeService();

